export default "__VITE_ASSET__CesuC1YU__"